import { InitFailedState } from '@/components/Errors/InitFailedState';

const AssetError = () => {
  return <InitFailedState />;
};

export default AssetError;
